var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-reset"},[_c('edit',{attrs:{"api":_vm.api,"fs":_vm.userResetPasswordFields,"customClassName":"none","title":"Reset Password"},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }